@for (symbol of symbols(); track symbol) {
  <td-wb-symbol-logo [symbol]="getSymbol(symbol)"
                     [market]="symbol.market"
                     [description]="symbol.description"
                     [size]="size()"/>
}
@if(overflow()) {
  <td-wb-symbol-logo-overflow [size]="size()"
                              [displayNumber]="overflow()"/>
}
